var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95664 5.3271L7.21748 3.63477H2.86958C2.38914 3.63477 2 4.01343 2 4.48093V18.8658C2 19.8004 2.77871 20.5581 3.73916 20.5581H20.2612C21.2216 20.5581 22.0003 19.8004 22.0003 18.8658V7.01944C22.0003 6.08485 21.2216 5.3271 20.2612 5.3271H8.95664Z",
    fill: "#E3F2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 7.7374H2V4.45529C2 4.00195 2.38914 3.63477 2.86958 3.63477H7.21748L8.95664 5.27582H20.2612C21.2216 5.27582 22.0003 6.0106 22.0003 6.91687V7.7374Z",
    fill: "#E3F2FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4884 7.73824H2.51367C2.51367 6.43607 2.51453 5.59888 2.51414 4.34116C2.51411 4.23492 2.60022 4.14844 2.70646 4.14844H7.12914L8.92404 5.81513L20.0902 5.79234C20.8619 5.79077 21.4884 6.41626 21.4884 7.188C21.4884 7.47421 21.4884 7.68406 21.4884 7.73824Z",
    fill: "#90C9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 7.73742H2V6.25021C2 5.79687 2.38914 5.42969 2.86958 5.42969H7.21748L8.95664 7.07074H22.0003C22.0003 7.481 22.0003 7.481 22.0003 7.73742Z",
    fill: "#E3F2FD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "folder.6a66c67f5c73647f72c75582a23a3c83.svg";